import { useNavigate } from 'react-router-dom';

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-orange-50/30">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b-4 border-orange-300" style={{ borderStyle: 'dashed' }}>
        <div className="container mx-auto px-6 h-20 flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-3 cursor-pointer">
            <div className="w-12 h-12 bg-gradient-to-br from-orange-400 to-red-400 rounded-full flex items-center justify-center shadow-lg" style={{ border: '3px dashed white' }}>
              <i className="ri-restaurant-2-line text-white text-xl"></i>
            </div>
            <div className="text-left">
              <h1 className="text-xl font-bold text-gray-900" style={{ fontFamily: '"Klee One", cursive' }}>
                シルバー料理教室
              </h1>
              <p className="text-xs text-orange-700" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
                合同会社シルバー
              </p>
            </div>
          </button>
          <button
            onClick={() => navigate('/')}
            className="px-5 py-3 rounded-full bg-gradient-to-r from-orange-400 to-red-400 text-white font-bold whitespace-nowrap"
            style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
          >
            ホームに戻る
          </button>
        </div>
      </nav>

      <main className="container mx-auto px-6 pt-32 pb-20">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl border-4 border-orange-300 p-8 md:p-12" style={{ borderStyle: 'dashed' }}>
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Klee One", cursive' }}>
              プライバシーポリシー
            </h2>
            <p className="text-lg text-gray-600" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
              個人情報の取り扱いについて
            </p>
          </div>

          <div className="space-y-8 text-gray-700" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
            <section>
              <p className="leading-relaxed">
                合同会社シルバー（以下「当社」）は、お客様の個人情報の保護を重要な責務と考え、適切な取り扱いと安全管理に努めます。
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" style={{ fontFamily: '"Klee One", cursive' }}>1. 取得する情報</h3>
              <p className="leading-relaxed">
                当社は、お問い合わせやサービスのご案内にあたり、氏名、メールアドレス、電話番号、お問い合わせ内容などの情報を取得する場合があります。
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" style={{ fontFamily: '"Klee One", cursive' }}>2. 利用目的</h3>
              <ul className="list-disc list-inside space-y-2 leading-relaxed">
                <li>お問い合わせへの対応</li>
                <li>レッスンやサービスに関するご案内</li>
                <li>運営上必要なご連絡</li>
                <li>サービス改善のための参考</li>
              </ul>
            </section>

            <section>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" style={{ fontFamily: '"Klee One", cursive' }}>3. 第三者提供</h3>
              <p className="leading-relaxed">
                当社は、法令に基づく場合を除き、ご本人の同意なく個人情報を第三者へ提供しません。
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" style={{ fontFamily: '"Klee One", cursive' }}>4. 安全管理</h3>
              <p className="leading-relaxed">
                当社は、個人情報への不正アクセス、漏えい、改ざん、紛失などを防ぐため、必要かつ適切な安全管理措置を講じます。
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" style={{ fontFamily: '"Klee One", cursive' }}>5. 開示・訂正等</h3>
              <p className="leading-relaxed">
                ご本人から自己の個人情報について開示、訂正、削除等のご希望があった場合は、適切に対応いたします。
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" style={{ fontFamily: '"Klee One", cursive' }}>6. お問い合わせ窓口</h3>
              <div className="bg-orange-50 rounded-2xl p-6 border-2 border-orange-200" style={{ borderStyle: 'dashed' }}>
                <p className="font-bold text-gray-900 mb-2">合同会社シルバー</p>
                <p>〒410-0822</p>
                <p>静岡県沼津市下香貫楊原670番地</p>
                <p>ドルチェヴィータ北館305</p>
              </div>
            </section>

            <section className="text-right text-gray-600">
              <p>合同会社シルバー</p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
